import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";
import { siteConfig } from "@/mocks/site";

const helpLinks = [
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
  { label: "新手吃瓜指南", to: "/zhinan/g1" },
  { label: "投稿与线索", to: "/about#contact" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-auto bg-accent-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-primary-600 font-hl text-xl leading-none">
                瓜
              </span>
              <div className="leading-none">
                <p className="font-display text-lg font-black text-background-50">吃瓜日报</p>
                <p className="mt-1 text-[10px] tracking-[0.24em] text-accent-200 uppercase">Melon Daily</p>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-accent-100/90">
              {siteConfig.desc}
            </p>
            <p className="mt-4 text-sm text-accent-100">
              品牌定位：{siteConfig.tagline}
            </p>
          </div>

          <div>
            <h4 className="font-display text-base font-bold text-background-50">吃瓜专区</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/#gua?cat=${c.id}`}
                    className="inline-flex items-center gap-1.5 text-sm text-accent-100/90 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    <i className={`${c.icon} text-accent-200`} />
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-base font-bold text-background-50">站内导航</h4>
            <ul className="mt-4 space-y-2.5">
              {helpLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-accent-100/90 transition-colors hover:text-background-50 cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-base font-bold text-background-50">关注更新</h4>
            <p className="mt-4 text-sm text-accent-100/90">
              热点更新不止，瓜单每日滚动。可把本站加入收藏，或常回来看看「本期瓜单」。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <Link
                to="/#gua"
                className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-accent-900 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-flashlight-line" />
                本期瓜单
              </Link>
              <Link
                to="/about#contact"
                className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-accent-600 transition-colors cursor-pointer"
              >
                <i className="ri-send-plane-line" />
                投稿线索
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-accent-700 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-accent-200">
            © 2026 {siteConfig.name} · 吃瓜群众视角看热点，吃瓜指南瓜单雷达
          </p>
          <p className="text-xs text-accent-200">
            投稿邮箱：hi@melon-daily.example · 理性吃瓜，友善进圈
          </p>
        </div>
      </div>
    </footer>
  );
}